import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import RichTextContainer from './RichTextContainer';

const RichTextContainerEditConfig = {
  emptyLabel: 'Rich Text Container',

  isEmpty: function(props: any): boolean {
    return !props;
  },
};

interface Props {
  text?: string;
}

class RichTextContainerWrapper extends Component<Props> {
  render(): JSX.Element {
    return <RichTextContainer {...this.props} />;
  }
}

export default MapTo('workplace-spa/components/rich-text-container')(
  RichTextContainerWrapper,
  RichTextContainerEditConfig,
);
